import { atom } from "jotai";

export const orderCreatedPopUpAtom = atom({
  isOpen: false,
});
